import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Result, Spin} from "antd";
import {Button, FontAwesomeIcon} from "~/components";
import {handleRequest} from "~/utils";
import {authApi} from "~/api";

// Khoá chống-gọi-lặp cấp module (StrictMode/remount có thể mount 2 lần):
// verify là idempotent phía BE nhưng gọi 1 lần vẫn sạch hơn.
let handledToken = null;

/**
 * Đích của link xác minh email (`/verify-email?uid=..&token=..`) — route CÔNG KHAI
 * (user bấm link từ hộp thư, có thể chưa đăng nhập). POST uid+token về BE rồi hiện
 * kết quả; thành công → mời đăng nhập (đã đăng nhập sẵn thì về trang chủ).
 */
function VerifyEmail() {

	const [state, setState] = useState({status: 'loading', message: ''});

	const isLoggedIn = Boolean(localStorage.getItem('access_token'));
	const home = process.env.REACT_APP_HOMEPAGE || '';

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const uid = params.get('uid');
		const token = params.get('token') || '';

		if (!uid || !token) {
			setState({status: 'error', message: 'Liên kết xác minh không hợp lệ hoặc thiếu tham số.'});
			return;
		}

		if (handledToken === token) return;
		handledToken = token;

		(async () => {
			const [error, response] = await handleRequest(authApi.verifyEmail(Number(uid), token));
			if (error || !response) {
				setState({
					status: 'error',
					message: error?.response?.data?.message || error?.message || 'Không xác minh được email. Vui lòng thử lại.',
				});
				return;
			}
			setState({status: 'success', message: response?.message || 'Xác minh email thành công.'});
		})();
	}, []);

	if (state.status === 'loading') {
		return (
			<div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 14}}>
				<Spin size="large" />
				<p style={{color: '#6b7280'}}>Đang xác minh email…</p>
			</div>
		);
	}

	return (
		<div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
			<Result
				status={state.status === 'success' ? 'success' : 'error'}
				title={state.status === 'success' ? 'Xác minh email thành công' : 'Không xác minh được email'}
				subTitle={state.message}
				extra={state.status === 'success' ? (
					<Button primary to={isLoggedIn ? '/' : '/login'}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-arrow-right-to-bracket" />}>
						{isLoggedIn ? 'Vào trang chủ' : 'Đăng nhập ngay'}
					</Button>
				) : (
					<p style={{color: '#6b7280', fontSize: 13}}>
						Nếu liên kết đã hết hạn, hãy <Link to={`${home}/login`}>đăng nhập</Link> rồi bấm
						"Gửi lại email xác minh" ở thông báo đầu trang.
					</p>
				)}
			/>
		</div>
	);
}

export default VerifyEmail;
